export default "<div class=\"circulation-options-container\">\r\n\r\n  <app-buy-sell-switcher></app-buy-sell-switcher>\r\n\r\n</div>\r\n";